import QuizStep from "@/icons/ui/quiz-step.svg";
import ReceiveTreatmentStep from "@/icons/ui/receive-treatment-step.svg";
import StartTreatmentStep from "@/icons/ui/start-treatment-step.svg";

export const data = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769768653/new_design/Image_a9rrlg.webp",
        icon: <QuizStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Complete our 2-minute health quiz",
        description: <>Help us understand your symptoms to see if Oestra<sup>®</sup> suits you.</>
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1770279841/new_design/Image_1_viourl.webp",
        icon: <ReceiveTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Receive your prescription treatment",
        description: "Once approved, your meds ship to your door. No visit needed."
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769768653/new_design/Image_2_etwvhu.webp",
        icon: <StartTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Start treatment and get ongoing support",
        description: "Our care team guides you with check-ins and recommendations for optimal results."
    },
];

export const CTA_TITLE = <span>Is Oestra<sup>®</sup> right for you?</span>;
